import { Check, Minus } from "@phosphor-icons/react";

function Tick({ on, label }) {
  return (
    <span
      title={label}
      className={`inline-flex h-5 w-5 items-center justify-center rounded-sm ${on ? "bg-[#059669]/12 text-[#059669]" : "bg-neutral-100 text-neutral-300"}`}
    >
      {on ? <Check size={13} weight="bold" /> : <Minus size={12} weight="bold" />}
    </span>
  );
}

// Two ticks: 1) a condition report exists for the asset, 2) any Condition/Utilisation/Environment field has data.
export function CondReportCell({ hasReport, hasValues, testid }) {
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={testid}>
      <Tick on={!!hasReport} label="Condition report exists" />
      <Tick on={!!hasValues} label="Condition / Utilisation / Environment has data" />
    </span>
  );
}

// Compact column header label with a legend tooltip.
export function CondReportHeader() {
  return (
    <span title="Cond Rpt Req — Tick 1: a condition report exists. Tick 2: Condition/Utilisation/Environment fields contain data.">
      Cond Rpt Req
    </span>
  );
}
